import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class IntegrationHealthDashboardRoute extends Route {
  @service featureFlags;
  @service router;

  titleToken = 'Integration Health Dashboard';

  beforeModel() {
    if (!this.featureFlags.isEnabled('integration-health-dashboard')) {
      void this.router.transitionTo('unauthorized');
    }
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    const locationId = controller.state.currentLocation?.id;
    controller.selectedLocation = locationId != null ? Number(locationId) : 'All locations';
    controller.fetchData();
    controller.startAutoRefresh();
  }

  deactivate() {
    this.controller.stopAutoRefresh();
  }
}
